// @ts-expect-error TS7016
import ReactUtils from "@/legacy/ReactUtils";
// @ts-expect-error TS7016
import TransactionUtils from "@/legacy/transaction/TransactionUtils.jsx";
import {StepDefinition} from "@/lib/types/checks.ts";
import {TxnResult} from "@/lib/types/transaction.ts";

export const formatDescription = (stepDef: StepDefinition, data: TxnResult): string => {
  const combinedStepDef = Object.assign({}, stepDef, {
    step_def: data.step_def,
    title: data.title,
    values: data.values || {},
  });
  let desc = TransactionUtils.formatStepDescription(combinedStepDef);

  if (data.error) {
    desc += '<br/><span class="fw-light text-danger"><small>' + ReactUtils.escapeHTML(data.error) + "</small></span>";
  }

  return desc;
};
